export default __webpack_public_path__ + "static/media/job_offer20_m.09560088.jpg";